
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hnaviCategory]/cost",
      function () {
        return require("private-next-pages/[hnaviCategory]/cost/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hnaviCategory]/cost"])
      });
    }
  